import { render, staticRenderFns } from "./LoaderSpinner.vue?vue&type=template&id=5b38e865&scoped=true"
import script from "./LoaderSpinner.vue?vue&type=script&lang=js"
export * from "./LoaderSpinner.vue?vue&type=script&lang=js"
import style0 from "./LoaderSpinner.vue?vue&type=style&index=0&id=5b38e865&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b38e865",
  null
  
)

export default component.exports